<script lang="ts" setup>

type Props = {
    isActive: boolean;
    size?: 4 | 8 | 12 | 16 | 18 | 20 | 24;
    label?: string;
};

withDefaults(
    defineProps<Props>(),
    { size: 16 }
);

const emit = defineEmits<{
    (e: 'favoriteChange', payload: boolean): void;
}>();
</script>

<template>
  <button type="button"
          class="cursor-pointer icon"
          v-bind="$attrs"
          aria-label="favorite"
          @click="emit('favoriteChange', !isActive)"
  >
    <svg :width="size"
         :height="size"
         viewBox="0 0 16 16"
         :class="{isActive}"
         fill="currentColor"
         xmlns="http://www.w3.org/2000/svg"
    >
      <Transition name="rotate"
                  mode="out-in"
      >
        <path v-if="isActive"
              d="M3.88325 14.0007L4.96659 9.31732L1.33325 6.16732L6.13325 5.75065L7.99992 1.33398L9.86659 5.75065L14.6666 6.16732L11.0333 9.31732L12.1166 14.0007L7.99992 11.5173L3.88325 14.0007Z"
        />
        <path v-else
              d="M5.89998 11.2173L7.99998 9.95065L10.1 11.234L9.54998 8.83398L11.4 7.23398L8.96665 7.01732L7.99998 4.75065L7.03331 7.00065L4.59998 7.21732L6.44998 8.83398L5.89998 11.2173ZM3.88331 14.0007L4.96665 9.31732L1.33331 6.16732L6.13331 5.75065L7.99998 1.33398L9.86665 5.75065L14.6666 6.16732L11.0333 9.31732L12.1166 14.0007L7.99998 11.5173L3.88331 14.0007Z"
        />
      </Transition>
    </svg>
    <span v-if="label"
          class="text-500-accent ml-4">
      {{ label }}
    </span>
  </button>
</template>

<style lang="scss" scoped>

.icon {
  display: flex;
  z-index: 5;
  place-content: center center;
  align-items: center;
  transition: 0.3s ease-in-out;
  background: none;
  color: var(--bg-primary);

  &:hover {
    opacity: 0.7
  }

  .isActive {
    color: var(  --content-brand-mojito);
  }
}

.rotate-enter-active {
  transition: all 0.2s ease-out;
}

.rotate-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.8, 0.9, 1);
}

.rotate-enter-from,
.rotate-leave-to {
  transform: rotateY(90deg);
  transform-origin: center center;
  opacity: 0;
}
</style>
